var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIdNo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 15,
    viewBox: "0 0 19 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3321 7.94289C17.9416 8.33342 17.3084 8.33342 16.9179 7.94289L16.5571 7.58211C16.1666 7.19158 16.1666 6.55842 16.5571 6.16789L16.575 6.15C16.7083 6.01667 16.8833 5.95 17.1 5.95C17.3167 5.95 17.4917 6.01667 17.625 6.15L18.35 6.875C18.4833 7.00833 18.55 7.18333 18.55 7.4C18.55 7.61667 18.4833 7.79167 18.35 7.925L18.3321 7.94289ZM10.5 15C9.94771 15 9.5 14.5523 9.5 14V13.6392C9.5 13.374 9.60536 13.1196 9.79289 12.9321L14.0679 8.65711C14.4584 8.26658 15.0916 8.26658 15.4821 8.65711L15.8429 9.01789C16.2334 9.40842 16.2334 10.0416 15.8429 10.4321L11.5679 14.7071C11.3804 14.8946 11.126 15 10.8608 15H10.5ZM1.25 9.75C0.835787 9.75 0.5 9.41421 0.5 9C0.5 8.58579 0.835786 8.25 1.25 8.25H7.25C7.66421 8.25 8 8.58579 8 9C8 9.41421 7.66421 9.75 7.25 9.75H1.25ZM1.25 5.625C0.835786 5.625 0.5 5.28921 0.5 4.875C0.5 4.46079 0.835786 4.125 1.25 4.125H11.5C11.9142 4.125 12.25 4.46079 12.25 4.875C12.25 5.28921 11.9142 5.625 11.5 5.625H1.25ZM1.25 1.5C0.835786 1.5 0.5 1.16421 0.5 0.75C0.5 0.335786 0.835786 0 1.25 0H11.5C11.9142 0 12.25 0.335786 12.25 0.75C12.25 1.16421 11.9142 1.5 11.5 1.5H1.25Z",
    fill: "#212121"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdNo);
export default __webpack_public_path__ + "static/media/id_no.6951f54baf70b577ad5f5f4fa9bcc78a.svg";
export { ForwardRef as ReactComponent };